import { AbstractControl, ValidationErrors } from '@angular/forms';
import { EditProfileService } from '../services/edit-profile.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export class UniqueMobileValidator {
  static createValidator(editProfileService: EditProfileService, loggedUserMobileNumber) {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
		if(loggedUserMobileNumber != control.value){
		  return editProfileService.isMobileNumberTaken(control.value).pipe(
			map(res => {
			  return res ? { 'notUniqueMobilenumber': true } : null
			})
		  )
		}
		return of(null)
	  }
  }
}